<template>
  <div>
    <NewAuction
      v-if="auctionSettings.id === 'create-new'"
      :categories="categories"
      @create="handleCreate"
    />
    <ActiveAuction
      v-else-if="status === 'NEW' || status === 'STARTED'"
      :categories="categories"
      :settings="auctionSettings"
      :auction-content="auctionContent"
      @delete="deleteAuction"
    />
    <FinishedAuction
      v-else-if="status === 'FINISHED' || status === 'PAID' || status === 'NOT_PAID'"
      :categories="categories"
      :settings="auctionSettings"
      :auction-content="auctionContent"
      @delete="deleteAuction"
    />
  </div>
</template>

<script>
import sellerService from '@/services/api/admin/stores/seller-service'
import auctionService from '@/services/api/admin/auction-service'

import NewAuction from '@/components/auction/NewAuction'
import ActiveAuction from '@/components/auction/ActiveAuction'
import FinishedAuction from '@/components/auction/FinishedAuction'

export default {
  name: 'Auction',
  components: {
    ActiveAuction,
    NewAuction,
    FinishedAuction,
  },
  data() {
    return {
      auctionSettings: {
        id: this.$route.params.id,
        title: '',
        activeFrom: null,
        activeTo: null,
        minFinishPrice: null,
        startPrice: null,
        minimumStep: null,
        ttl: null,
        isPaid: null,
        winnerId: null,
        startDate: null,
        endDate: null,
        hash_id: null,
      },
      title: '',
      status: null,
      bidList: [],
      auctionCategories: [],
      lotPromotions: [],
      categories: [],
      blockedCategories: [],
      sectionPlaces: [],
    }
  },

  computed: {
    auctionContent() {
      return {
        title: this.title,
        status: this.status,
        bidList: this.bidList,
        auctionCategories: this.auctionCategories,
        lotPromotions: this.lotPromotions,
        sectionPlaces: this.sectionPlaces,
      }
    },
  },

  async mounted() {
    await this.getCategories()
    if (this.auctionSettings.id !== 'create-new') {
      this.fetchAuction()
    }
  },

  methods: {
    fetchAuction() {
      auctionService.getAuctionById(this.$route.params.id)
        .then(({ data: { content } }) => {
          this.auctionSettings = this.mapAuctionSettings(content)
          this.bidList = content.auctionBids.sort((a, b) => b.price - a.price)
          this.status = content.status
          this.title = content.auction_name
          this.auctionCategories = content.auctionSubCategories
          this.lotPromotions = content.lotPromotion
          this.sectionPlaces = this.mapSectionPlaces(content.sectionPlaces)
        })
    },

    // function by https://stackoverflow.com/users/1021714/braza
    partition(array, isValid) {
      return array.reduce(([pass, fail], elem) => {
        return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]]
      }, [[], []])
    },

    mapSectionPlaces(sectionPlaces) {
      const getSectionTitle = (id) => {
        let res = null
        this.categories.forEach(cat => {
          cat.children.forEach(subCat => {
            const sec = subCat.children.find(section => {
              return section.key === `section_${id}`
            })
            if (sec) {
              res = sec
            }
          })
        })
        return res?.title
      }

      const mapped = sectionPlaces.map(section => {
        const [free, placed] = this.partition(section.sectionPlaces, place => place.product_id === null)
        section.freeSlots = free.sort((a, b) => b.position - a.position)
        section.sectionPlaces = placed
        section.title = getSectionTitle(section.sectionId)
        return section
      })

      return mapped.sort((a, b) => {
        const titleA = a.title.toLowerCase(); const titleB = b.title.toLowerCase()
        if (titleA < titleB) {
          return -1
        }
        if (titleA > titleB) {
          return 1
        }
        return 0
      })
    },

    mapAuctionSettings(content) {
      return {
        ...content.auctionSettings,
        activeFrom: content.active_from,
        activeTo: content.active_to,
        id: content.id,
      }
    },

    async getCategories() {
      try {
        let res = await auctionService.getBlockedCategories()
        this.blockedCategories = res.data.content

        res = await sellerService.categories()
        this.categories = res.data.content.map(category => {
          const mappedCategory = {
            key: `category_${category.id}`,
            title: this.$l(category.title),
            children: category.sub_categories.map(sub => {
              const mappedSubCat = {
                key: `subCategory_${sub.id}`,
                title: this.$l(sub.title),
                children: sub.sections.map(section => {
                  return {
                    key: `section_${section.id}`,
                    title: this.$l(section.title),
                    disableCheckbox: this.blockedCategories.includes(section.id),
                  }
                }),
              }
              mappedSubCat.disableCheckbox = mappedSubCat.children.reduce((sum, child) => {
                return sum && child.disableCheckbox
              }, true)
              return mappedSubCat
            }),
          }
          mappedCategory.disableCheckbox = mappedCategory.children.reduce((sum, child) => {
            return sum && child.disableCheckbox
          }, true)
          return mappedCategory
        })
      } catch (error) {
        console.log(error)
      }
    },

    async handleCreate(payload) {
      await auctionService.createAuction(payload)
      this.$router.push('/admin/auctions')
    },

    deleteAuction() {
      auctionService.deleteAuction(this.$route.params.id)
    },

  },
}
</script>
